import { createQuery } from '@tanstack/svelte-query';
import { fetchRooms } from '$lib/api/room';
import { fetchZones } from '$lib/api/zone';
import type { RoomResponse } from '$lib/types/room';
import { resolveScope, getUnitScope, type ScopeFn } from './scope';

export const roomsQuery = (scope: ScopeFn = getUnitScope()) =>
	createQuery<Array<RoomResponse>>(() => {
		const unitId = resolveScope(scope);
		return {
			queryKey: ['rooms', { unitId }],
			queryFn: async () => {
				const [allRooms, allZones] = await Promise.all([fetchRooms(), fetchZones()]);
				const zoneIds = new Set(allZones.filter((z) => z.unit === unitId).map((z) => z.id));
				return allRooms.filter((r) => zoneIds.has(r.zone));
			},
			enabled: unitId > 0
		};
	});
